export default "__VITE_ASSET__Bc6z5YT___"